/**
 * Falha ao baixar o pedaço (chunk) de uma tela depois de um deploy. Quem está
 * com o painel aberto roda o build de antes, que pede os chunks pelos hashes
 * de antes; o deploy troca esses arquivos, o pedido volta 403 e o `import()`
 * da tela rejeita. Atualizar a página traz o build novo, então o painel
 * recarrega sozinho, uma vez.
 */

/** Guarda, na aba, quando o painel recarregou por isso. */
export const CHUNK_RELOAD_KEY = 'ops-panel:recarregou-por-chunk';

/** Falhou de novo logo depois de recarregar: não recarrega outra vez. */
export const CHUNK_RELOAD_GUARD_MS = 60 * 1000;

const CHUNK_MESSAGE = /Loading (CSS )?chunk [\w-]+ failed/i;

/** JS (`ChunkLoadError`, do webpack) ou CSS (do mini-css-extract-plugin). */
export const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  const {code} = error as Error & {code?: string};
  return (
    error.name === 'ChunkLoadError' ||
    code === 'CSS_CHUNK_LOAD_FAILED' ||
    CHUNK_MESSAGE.test(error.message)
  );
};

/**
 * Recarrega a página, a não ser que tenha recarregado por isso há pouco.
 * Sem o armazenamento da aba não recarrega: nada impediria um laço.
 */
export const reloadOnceAfterChunkError = (
  now: number = Date.now(),
  reload: () => void = () => window.location.reload()
): boolean => {
  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY));
    if (last && now - last < CHUNK_RELOAD_GUARD_MS) return false;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
  } catch (error) {
    return false;
  }
  reload();
  return true;
};
